import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamFormComponent } from './team-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { TeamService } from './team.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { AngularDualListBoxModule } from '../dual-list/angular-dual-listbox.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';




@NgModule({
    declarations: [
        TeamFormComponent
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        FuseSharedModule,
        AngularDualListBoxModule
    ],
    exports:[
        TeamFormComponent
    ],
    providers : [ 
        TeamService
    ]
})
export class TeamFormModule { }
